// extracted by mini-css-extract-plugin
export default {"statusNotification":"roqTZ___UploadStatus-module__statusNotification","error":"Sqy-0___UploadStatus-module__error"};